import { LOCAL_STORAGE_KEYS, BEAM_COOKIE_NAMES } from "../api-sdk/constants";
import { createScopedLocalStorage } from "./local-storage";
import { deleteCookieValue } from "./cookies";

/**
 * Clears every piece of Beam-related browser state this SDK writes, by iterating the
 * LOCAL_STORAGE_KEYS/BEAM_COOKIE_NAMES registries (src/api-sdk/constants.ts) directly —
 * anything added to those objects is cleared automatically, with nothing to update here.
 *
 * Not tied to any one integration's lifecycle (e.g. registerCartIntegration/
 * unregisterCartIntegration) — safe to call on its own, from any integration or directly,
 * whenever a full reset of Beam's local footprint is needed.
 */
export function clearBeamStorage(config: { apiKey: string; domain?: string }) {
  const localStorage = createScopedLocalStorage(config);
  Object.values(LOCAL_STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  Object.values(BEAM_COOKIE_NAMES).forEach((name) => deleteCookieValue({ name, domain: config.domain, path: "/" }));
}
